import * as d3 from 'd3';
import * as topojson from 'topojson-client';

const closure = mainApp => {
    mainApp.mapScale = 1;

    mainApp.buildMap = function() {
        mainApp.svg = d3.select('#map-svg');

        mainApp.tooltip = d3
            .select('#svg-holder')
            .append('div')
            .attr('class', 'tooltip')
            .style('position', 'absolute')
            .style('display', 'none');

        mainApp.tooltip.append('span');

        mainApp.tooltipInfo = d3
            .select('#svg-holder')
            .append('div')
            .attr('class', 'tooltip-info')
            .style('position', 'absolute')
            .style('display', 'none');

        mainApp.zoom = d3
            .zoom()
            .scaleExtent([1, 10])
            .translateExtent([[0, 0], [mainApp.params.width + 100, mainApp.params.height]])
            .on('zoom', mainApp.zoomed);

        mainApp.mapContainer = mainApp.svg.append('g');

        mainApp.map = mainApp.mapContainer
            .append('g')
            .attr('class', 'map-svg-map')
            .attr('width', mainApp.params.width)
            .attr('height', mainApp.params.height - 150);

        mainApp.map
            .append('defs')
            .append('path')
            .datum({ type: 'Sphere' })
            .attr('id', 'sphere')
            .attr('d', mainApp.path);

        mainApp.map
            .append('use')
            .attr('class', 'stroke')
            .attr('xlink:href', '#sphere');

        mainApp.map
            .append('use')
            .attr('class', 'fill')
            .attr('xlink:href', '#sphere');

        mainApp.land = mainApp.map
            .insert('path', '.graticule')
            .datum(topojson.feature(mainApp.worldMap, mainApp.worldMap.objects.land))
            .attr('class', 'land')
            .attr('d', mainApp.path);

        mainApp.bounds = mainApp.map
            .insert('path', '.graticule')
            .datum(
                topojson.mesh(mainApp.worldMap, mainApp.worldMap.objects.countries, function(a, b) {
                    return a !== b;
                })
            )
            .attr('class', 'boundary')
            .attr('d', mainApp.path);

        // add cities to svg
        mainApp.cities = mainApp.map
            .selectAll('circle')
            .data(mainApp.cities)
            .enter()
            .append('circle')
            .attr('class', 'bubble')
            .attr('cx', function(d) {
                return mainApp.projection([d.LON, d.LAT])[0];
            })
            .attr('cy', function(d) {
                return mainApp.projection([d.LON, d.LAT])[1];
            })
            .attr('r', function(d) {
                var radius = mainApp.params.scales.bubble(
                    mainApp.popSize(d, mainApp.params.yearScale.domain[0])
                );
                return Math.round(10 * radius) / 10 + 'px';
            })
            .attr('fill', 'gray')
            .style('stroke-width', function() {
                return mainApp.params.bubbleStroke.normal / mainApp.mapScale + 'px';
            })
            .on('mouseover', function(d) {
                d3.select(this).style('stroke-width', function() {
                    return mainApp.params.bubbleStroke.hover / mainApp.mapScale + 'px';
                });
                mainApp.tooltip.style('display', 'block');
                mainApp.tooltip.selectAll('span').html(d.CITY);
            })
            .on('mousemove', function() {
                var coords = d3.mouse(d3.select('#map-svg').node());

                mainApp.tooltip.style('top', coords[1] + 180 + 'px');
                if (d3.event.pageX < 550) {
                    mainApp.tooltip.style('left', coords[0] + 40 + 'px');
                    mainApp.tooltip.style('right', null);
                } else {
                    mainApp.tooltip.style('right', 956 - coords[0] + 40 + 'px');
                    mainApp.tooltip.style('left', null);
                }
            })
            .on('mouseout', function() {
                d3.select(this).style('stroke-width', function() {
                    return mainApp.params.bubbleStroke.normal / mainApp.mapScale + 'px';
                });
                mainApp.tooltip.style('display', 'none');
                mainApp.tooltipInfo.style('display', 'none');
                mainApp.tooltipInfo.html('');
            })
            .on('click', function(d) {
                var data = d;
                mainApp.tooltip.style('display', 'none');

                var coords = d3.mouse(d3.select('#map-svg').node());

                mainApp.tooltipInfo.style('top', coords[1] + 180 + 'px');
                if (d3.event.pageX < 550) {
                    mainApp.tooltipInfo.style('left', coords[0] + 40 + 'px');
                    mainApp.tooltipInfo.style('right', null);
                } else {
                    mainApp.tooltipInfo.style('right', 956 - coords[0] + 40 + 'px');
                    mainApp.tooltipInfo.style('left', null);
                }

                mainApp.tooltipInfo.style('display', 'block').html(function() {
                    var yr = mainApp.yearDisp.select('text').text();
                    var pop = mainApp.popSize(d, yr);
                    var rate;
                    var refYear = Math.floor((yr * 2) / 10) * 5;
                    if (refYear === 2030) {
                        rate = d['2025-2030'];
                    } else {
                        rate = d[refYear.toString() + '-' + (refYear + 5).toString()];
                    }
                    rate = Math.round(rate * 10) / 10;
                    var curPop;
                    if (yr === 2015) {
                        curPop = Math.round(data['2015']) * 1000;
                    } else {
                        curPop = Math.round(pop * 1000);
                    }
                    var text = '';
                    text += '<h3>' + data.CITY + '</h3>';
                    text += '<h4>' + data.CTRY + ' (' + d.CONT + ')</h4>';
                    text +=
                        '<p>' +
                        '<span>Population (' +
                        yr +
                        '): </span>' +
                        curPop.toLocaleString() +
                        '</p>';
                    text +=
                        '<p>' +
                        '<span>Growth Rate (' +
                        yr +
                        '): </span>' +
                        rate.toLocaleString() +
                        '% per year</p>';
                    text +=
                        '<p>' +
                        '<span>Population (2015): </span>' +
                        (Math.round(data['2015']) * 1000).toLocaleString() +
                        '</p>';
                    return text;
                });
            });

        mainApp.mapContainer.call(mainApp.zoom);

        mainApp.cities.on('drag', null);
        mainApp.cities.on('zoom', null);

        // bubble legend
        var legendVals = [1e6, 3e6, 5e6, 10e6, 30e6];

        var bubbleLegendHolder = mainApp.svg
            .append('g')
            .attr('class', 'legend')
            .attr(
                'transform',
                'translate(' +
                    (mainApp.params.width - 160) +
                    ',' +
                    (mainApp.params.height - 40) +
                    ')'
            );

        var bubbleLegend = bubbleLegendHolder
            .selectAll('g')
            .data(legendVals)
            .enter()
            .append('g');

        bubbleLegend
            .append('circle')
            .attr('cx', function(d, i) {
                return (
                    ((10 + 2 * mainApp.params.scales.bubble(legendVals[i - 6] / 1000)) | 0) +
                    ((10 + 2 * mainApp.params.scales.bubble(legendVals[i - 5] / 1000)) | 0) +
                    ((10 + 2 * mainApp.params.scales.bubble(legendVals[i - 4] / 1000)) | 0) +
                    ((10 + 2 * mainApp.params.scales.bubble(legendVals[i - 3] / 1000)) | 0) +
                    ((10 + 2 * mainApp.params.scales.bubble(legendVals[i - 2] / 1000)) | 0) +
                    ((10 + 2 * mainApp.params.scales.bubble(legendVals[i - 1] / 1000)) | 0) +
                    mainApp.params.scales.bubble(d / 1000)
                );
            })
            .attr('cy', function(d) {
                return -mainApp.params.scales.bubble(d / 1000);
            })
            .attr('r', function(d) {
                return mainApp.params.scales.bubble(d / 1000);
            })
            .style('fill', 'none');

        bubbleLegend
            .append('text')
            .attr('class', 'text-header')
            .attr('x', function(d, i) {
                return (
                    ((10 + 2 * mainApp.params.scales.bubble(legendVals[i - 6] / 1000)) | 0) +
                    ((10 + 2 * mainApp.params.scales.bubble(legendVals[i - 5] / 1000)) | 0) +
                    ((10 + 2 * mainApp.params.scales.bubble(legendVals[i - 4] / 1000)) | 0) +
                    ((10 + 2 * mainApp.params.scales.bubble(legendVals[i - 3] / 1000)) | 0) +
                    ((10 + 2 * mainApp.params.scales.bubble(legendVals[i - 2] / 1000)) | 0) +
                    ((10 + 2 * mainApp.params.scales.bubble(legendVals[i - 1] / 1000)) | 0) +
                    mainApp.params.scales.bubble(d / 1000)
                );
            })
            .attr('y', 0)
            .attr('dy', '1.3em')
            .style('font-size', '12px')
            .style('font-weight', 'bold')
            .text(d3.format('.1s'));

        // color legend
        var colorLegendHolder = mainApp.svg
            .append('g')
            .attr('class', 'legend')
            .attr('transform', 'translate(' + 80 + ',' + (mainApp.params.height - 75) + ')');

        var gradient = colorLegendHolder
            .append('defs')
            .append('linearGradient')
            .attr('id', 'gradient')
            .attr('x1', '0%')
            .attr('y1', '0%')
            .attr('x2', '100%')
            .attr('y2', '0%')
            .attr('spreadMethod', 'pad');

        gradient
            .append('stop')
            .attr('offset', '0%')
            .attr('stop-color', mainApp.params.colorScale.range[0])
            .attr('stop-opacity', 1);

        gradient
            .append('stop')
            .attr('offset', '50%')
            .attr('stop-color', mainApp.params.colorScale.range[2])
            .attr('stop-opacity', 1);

        gradient
            .append('stop')
            .attr('offset', '100%')
            .attr('stop-color', mainApp.params.colorScale.range[4])
            .attr('stop-opacity', 1);

        colorLegendHolder
            .append('rect')
            .attr('width', 180)
            .attr('height', 30)
            .style('fill', 'url(#gradient)')
            .style('opacity', 0.9)
            .attr('stroke', '#fff')
            .attr('stroke-width', mainApp.params.bubbleStroke.normal);

        colorLegendHolder
            .append('text')
            .attr('class', 'text-header')
            .attr('y', 18)
            .attr('x', -33)
            .style('font-size', '12px')
            .style('font-weight', 'bold')
            .text('Shrinking');

        colorLegendHolder
            .append('text')
            .attr('class', 'text-header')
            .attr('y', 18)
            .attr('x', 210)
            .style('font-size', '12px')
            .style('font-weight', 'bold')
            .text('Growing');

        // year indicator
        mainApp.yearDisp = mainApp.svg
            .append('g')
            .attr('class', 'year-display')
            .attr(
                'transform',
                'translate(' +
                    (mainApp.params.width +
                        mainApp.params.margin.left +
                        mainApp.params.margin.right) /
                        2 +
                    ',' +
                    (mainApp.params.height - 180) +
                    ')'
            );

        mainApp.yearDisp
            .append('text')
            .attr('class', 'year-display-text text-header')
            .attr('text-anchor', 'middle')
            .text('1950');

        // slider
        mainApp.slider = mainApp.svg
            .append('g')
            .attr('class', 'slider')
            .attr(
                'transform',
                'translate(' +
                    mainApp.params.margin.left +
                    ',' +
                    (mainApp.params.height - 150) +
                    ')'
            );

        mainApp.slider
            .append('line')
            .attr('class', 'track')
            .attr('x1', mainApp.params.scales.year.range()[0])
            .attr('x2', mainApp.params.scales.year.range()[1])
            .select(function() {
                return this.parentNode.appendChild(this.cloneNode(true));
            })
            .attr('class', 'track-inset')
            .select(function() {
                return this.parentNode.appendChild(this.cloneNode(true));
            })
            .attr('class', 'track-overlay')
            .call(
                d3
                    .drag()
                    .on('start.interrupt', function() {
                        mainApp.slider.interrupt();
                    })
                    .on('start drag', function() {
                        mainApp.year(mainApp.params.scales.year.invert(d3.event.x));
                    })
            );

        mainApp.slider
            .insert('g', '.track-overlay')
            .attr('class', 'ticks')
            .attr('transform', 'translate(0,' + 24 + ')')
            .selectAll('text')
            .data(mainApp.params.scales.year.ticks(mainApp.params.yearScale.ticks))
            .enter()
            .append('text')
            .attr('class', 'text-header')
            .attr('x', mainApp.params.scales.year)
            .attr('text-anchor', 'middle')
            .text(function(d) {
                return d;
            });

        mainApp.handle = mainApp.slider
            .insert('circle', '.track-overlay')
            .attr('class', 'handle')
            .attr('r', 12);
    };
};

export default closure;
